const transData = (transferData,initialValues) => {
  console.log(transferData,initialValues,"reinitializeupdated")
    var initialVal = {};
    Object.entries(initialValues).map((field, index) => {
      if (field[0] === "primaryDetails") {
        initialVal[`${field[0]}`] = {};
        let obj = {};
        Object.entries(field[1]).map((inField, ind) => {
          if (inField[0] === "Plan") {
            obj["Plan"] = {};
            Object.entries(inField[1]).map((innerField, ind) => {
              
              if(transferData.hasOwnProperty(innerField[0])){
                obj.Plan[`${innerField[0]}`] = transferData[`${innerField[0]}`]
              }else{
                if(innerField[0] === "LifeCoverType"){
                  console.log('dd',innerField)
                  obj.Plan[`${innerField[0]}`] = "2032"
                }else{
                  obj.Plan[`${innerField[0]}`]=innerField[1]
                }
               
              }
              
              
             
            });
          } 
          else if(inField[0]==="UserID" ||inField[0]==="ApplicationNo" ){
              obj["UserID"]=transferData.UserID;
              obj["ApplicationNo"]=transferData.ApplicationNo
          }
          else if(inField[0]==="Family"){
            const fammembers=["101","102"]
            obj["Family"] = [];
            for(let i=0;i<=1;i++){
              const familyobj={}
              Object.entries(inField[1][0]).map((field,ind)=>{
                  if(field[0]==="Relationship"){
                    familyobj[field[0]]=fammembers[i]
                  }
                  else{
                    familyobj[field[0]]=''
                  }
              })
              obj.Family.push(familyobj)
            }
          }
          else {
            obj[`${inField[0]}`] = inField[1];
          }
        });
        // obj.Plan = { ...obj.Plan, ...transferData };
        initialVal.primaryDetails=obj;
      } else {
        initialVal[`${field[0]}`] = field[1];
      }
    });
    // console.log(initialVal,"initialVal")
    return initialVal;
  };
  
  export default transData;
  